/**
 * StatisticsView.tsx - Módulo pendiente de implementación
 *
 * Se integrará con transferencias y boletas electrónicas en una fase futura.
 *
 * @version 1.1.0
 * @author Conectemos Chile
 */

import React from 'react';
import './StatisticsView.css';

interface StatisticsViewProps {
  therapist: any;
}

const StatisticsView: React.FC<StatisticsViewProps> = (_props) => {
  return (
    <div className="statistics-view">
      <div className="statistics-view__header">
        <div className="statistics-view__header-content">
          <h2>
            <i className="fas fa-chart-bar"></i>
            Estadísticas
          </h2>
        </div>
      </div>

      <div className="sii-integration-card">
        <div className="sii-badge">Próximamente</div>
        <div className="sii-icon">
          <i className="fas fa-chart-bar"></i>
        </div>
        <h3 className="sii-title">Módulo en desarrollo</h3>
        <p className="sii-description">
          Este módulo estará disponible próximamente. Se integrará con transferencias y boletas electrónicas.
        </p>
        <div className="sii-features">
          <div className="sii-feature">
            <i className="fas fa-check-circle"></i>
            <span>Métricas de ingresos y sesiones</span>
          </div>
          <div className="sii-feature">
            <i className="fas fa-check-circle"></i>
            <span>Evolución de pacientes</span>
          </div>
          <div className="sii-feature">
            <i className="fas fa-check-circle"></i>
            <span>Reportes exportables</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatisticsView;